import {Center} from '~/components/Center';
import {Paragraph} from '~/components/Paragraph';
import {Title} from '~/components/Title';
import {SectionQuote} from './SectionQuoute';
import {HorizontalDivider} from '~/components/HorizontalDivider';
import {TitleSection} from '~/components/TitleSection';
import {useTranslation} from 'react-i18next';
import {ServicesPageType} from '~/services/GetPageServicesService';
import {ImageHeader} from '~/features/shared';

const servicios = [
  {
    title: 'manufactura',
    content: 'pages:servicios:manufactura',
  },
  {
    title: 'instalacion',
    content: 'pages:servicios:instalacion',
  },
  {
    title: 'mantenimiento',
    content: 'pages:servicios:mantenimiento',
  },
  {
    title: 'renta',
    content: 'pages:servicios:renta',
  },
];

export function ServicesPage({page}: {page: ServicesPageType}) {
  const {t} = useTranslation();

  return (
    <Center className="w-full lg:px-20 lg:pt-10">
      <ImageHeader
        image={page.headerImage}
        breadcrumb={[
          {
            title: t('inicio'),
            to: '/',
          },
          {
            title: t('servicios'),
          },
        ]}
        title={t('servicios')}
      />

      <div className="px-5 sm:px-10">
        <section className="flex flex-col gap-8 items-center md:flex-row md:items-start">
          <img
            src={page.imagen1?.image.url}
            alt={page.imagen1?.image.altText}
            className="hidden object-cover bg-black rounded-3xl md:block"
            width={350}
            height={300}
            loading="eager"
            style={{
              width: 350,
              height: 300,
            }}
          />

          <div className="flex-1">
            <TitleSection i18nKey="pages:servicios:title.0" className="mb-4" />

            <Title
              i18nKey="pages:servicios:title.1"
              className="mb-6 text-2xl leading-normal sm:text-4xl"
            />

            <Paragraph i18nKey="pages:servicios:content" />
          </div>

          <img
            src={page.imagen1?.image.url}
            alt={page.imagen1?.image.altText}
            className="object-cover bg-black rounded-3xl md:hidden"
            width={350}
            height={300}
            loading="eager"
            style={{
              width: 350,
              height: 300,
            }}
          />
        </section>

        <HorizontalDivider className="my-16 md:mb-28" />

        <section>
          <Title
            i18nKey="nuestros-servicios"
            className="mb-10 text-2xl leading-normal text-center sm:text-4xl"
          />

          <div className="grid grid-cols-1 auto-rows-auto gap-10 mb-12 md:grid-cols-2">
            {servicios.map((s) => (
              <div key={s.title}>
                <Title
                  i18nKey={s.title}
                  level="h2"
                  className="mb-4 text-xl leading-normal sm:text-2xl"
                />

                <Paragraph className="text-gray-500" i18nKey={s.content} />
              </div>
            ))}
          </div>

          <div>
            <Title
              i18nKey="mantenimiento-operativo"
              level="h2"
              className="mb-4 text-xl leading-normal sm:text-2xl"
            />

            <Paragraph
              className="text-gray-500"
              i18nKey="pages:servicios:mantenimiento_operativo"
            />
          </div>
        </section>

        <HorizontalDivider className="my-16 md:mt-28" />

        <SectionQuote image={page.cotizarImage} />
      </div>
    </Center>
  );
}
